import api from "../../../core/api";
import {
  MachineGroupViewModel,
  MachineGroupDetailViewModel,
  ChangeMachineGroupViewModel,
  AddMachinesToGroupViewModel,
} from "../models/groupModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
};

class MachineGroupsApi {
  getGroups(groupType?: string): Promise<MachineGroupViewModel[]> {
    return api
      .get<MachineGroupViewModel[]>(`/v1/customer/machine-groups`, {
        ...getRequestConfig(),
        params: groupType ? { groupType } : undefined,
      })
      .then((x) => x.data);
  }

  getGroupDetail(id: string): Promise<MachineGroupDetailViewModel> {
    return api
      .get<MachineGroupDetailViewModel>(
        `/v1/customer/machine-groups/${id}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  createGroup(model: ChangeMachineGroupViewModel): Promise<string> {
    return api
      .post<string>(`/v1/customer/machine-groups`, model, getRequestConfig())
      .then((x) => x.data);
  }

  updateGroup(id: string, model: ChangeMachineGroupViewModel): Promise<void> {
    return api
      .put<void>(
        `/v1/customer/machine-groups/${id}`,
        model,
        getRequestConfig()
      )
      .then(() => undefined);
  }

  deleteGroup(id: string): Promise<void> {
    return api
      .delete(`/v1/customer/machine-groups/${id}`, getRequestConfig())
      .then(() => undefined);
  }

  addMachinesToGroup(
    groupId: string,
    model: AddMachinesToGroupViewModel
  ): Promise<void> {
    return api
      .post<void>(
        `/v1/customer/machine-groups/${groupId}/machines`,
        model,
        getRequestConfig()
      )
      .then(() => undefined);
  }

  removeMachineFromGroup(
    groupId: string,
    machineId: string
  ): Promise<void> {
    return api
      .delete(
        `/v1/customer/machine-groups/${groupId}/machines/${machineId}`,
        getRequestConfig()
      )
      .then(() => undefined);
  }
}

export default new MachineGroupsApi();
